import { Input } from '@/components/ui/input';

interface DateInputProps {
  value: {
    year: string;
    month: string;
    day: string;
  };
  onChange: (value: { year: string; month: string; day: string }) => void;
  isHijri: boolean;
}

export function DateInput({ value, onChange, isHijri }: DateInputProps) {
  const handleChange = (field: 'year' | 'month' | 'day', inputValue: string) => {
    const numValue = inputValue.replace(/\D/g, '');
    onChange({ ...value, [field]: numValue });
  };

  return (
    <div className="flex gap-2">
      <Input
        placeholder="السنة"
        value={value.year}
        onChange={(e) => handleChange('year', e.target.value)}
        maxLength={4}
        className="text-center"
      />
      <Input
        placeholder="الشهر"
        value={value.month}
        onChange={(e) => handleChange('month', e.target.value)}
        maxLength={2}
        className="text-center"
      />
      <Input
        placeholder="اليوم"
        value={value.day}
        onChange={(e) => handleChange('day', e.target.value)}
        maxLength={2}
        className="text-center"
      />
    </div>
  );
}